import type { IDeepOmit, IDeepReplaceSuffix } from '@bcc-life/sandbox';

import type { ruTranslations } from './ru';

export const kzTranslations: IDeepReplaceSuffix<
  IDeepOmit<typeof ruTranslations, `${string}_few`>,
  '_many',
  '_other'
> = {
  translation: {
    agreementFile: 'Правила СЖЗ.pdf',
    keyInformationDocument: 'Ключевой информационный документ',
    no: 'No',
    questionnaire: {
      blockHeader: 'Вы несколько раз ввели неверно SMS-код',
      blockMessage:
        'Чтобы обезопасить ваши данные, мы временно заблокировали доступ.Попробуйте ещё раз через 24 часа или обратитесь в отделение',
      doYouHaveAnyIllnesses: 'Do you have any of the following diseases?',
      enterCode: 'Enter the code',
      incorrectSmsCode: 'Incorrect SMS code entered. Try again',
      incorrectSmsCodeMoreOne: 'Неверный код. Осталось {{count}} попытки',
      incorrectSmsCodeOne: 'Неверный код. Осталась {{count}} попытка',
      insuranceQuestionnaire: 'Insurance Questionnaire',
      notFound: 'Анкета не найдена!',
      notFoundDescription: 'Заявка с данным ID не существует.',
      ok: 'Ok',
      processedApplication: 'Данная заявка была уже ранее отправлена',
      processedApplicationDescription: '',
      recallCodeAgain: 'Request code again in {{seconds}} seconds',
      requestAgain: 'Request again',
      sentCodeToPhoneNumber: 'We have sent an SMS code to your phone number',
      surveyIllnessOptions: {
        cardiovascularSystem: 'Cardiovascular system',
        diabetes: 'Diabetes',
        hepatitisBOrC: 'Hepatitis B or C',
        kidneys: 'Kidneys',
        oncology: 'Oncological',
        respiratorySystem: 'Lungs or respiratory tract',
      },
    },
    yes: 'Yes',
  },
};
